import { Navigate } from 'react-router-dom';

import getSignInPathDefault from '../../utils/getSignInPathDefault';

export const SiteCatchall = () => {
  return <Navigate to={getSignInPathDefault()} />;
};
